import { render, staticRenderFns } from "./DormitoryOccupancy.vue?vue&type=template&id=d95da9c2&scoped=true"
import script from "./DormitoryOccupancy.vue?vue&type=script&lang=js"
export * from "./DormitoryOccupancy.vue?vue&type=script&lang=js"
import style0 from "./DormitoryOccupancy.vue?vue&type=style&index=0&id=d95da9c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95da9c2",
  null
  
)

export default component.exports